import { useAliyunOssUpload } from '@/utils/aliyunOss'
import OSS from 'ali-oss'
import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import BasicLayout from '../components/basic-layout/index.vue'
import { checkMd5, getOssToken } from '../model/api'

const proSource = '上传试卷'
const { getMd5, uploadAliyunOss } = useAliyunOssUpload()
const prefix = 'https://cdn-tiku.17zuoye.cn/'

@Component({ components: { BasicLayout } })
export default class AssessmentUpload extends Vue {
  // 已经上传的文件列表（受控）
  private fileList: any[] = []
  private ossClient: any = null
  private folder: any = null
  private showDelete = false
  private get subject() {
    return this.$store.state.subject
  }
  public created() {
    this.getOssToken()
  }
  public async getOssToken() {
    const data: any = await getOssToken()
    if (data && Object.keys(data).length > 0) {
      const client = new OSS({
        region: data.Region,
        accessKeyId: data.AccessKeyId,
        accessKeySecret: data.AccessKeySecret,
        stsToken: data.SecurityToken,
        bucket: data.Bucket
      })
      this.ossClient = client
      this.folder = data.Folder
    }
  }
  public uploadFile(file: any) {
    const self = this
    Promise.all([this.ossClient, getMd5(file)]).then(async ([oss, md5]: Array<any>) => {
      const originalFileName = file.name || ''
      let surfix = ''
      console.log(originalFileName)
      if (originalFileName.indexOf('.') > -1) {
        surfix = originalFileName.split('.').pop()
      }
      const newName = this.folder + (surfix ? `${md5}.${surfix}` : md5)
      const newUploadingItem = {
        file,
        client: oss,
        tempCheckpoint: undefined,
        filename: newName,
        // 其他
        name: originalFileName,
        progress: 0
      }
      uploadAliyunOss(newUploadingItem).then(() => {
        // 上传成功之后回调
        // console.log({ url: prefix + newName, name: newUploadingItem.name, progress: 100 })
        this.fileList = [{ url: prefix + newName, name: newUploadingItem.name, progress: 100 }]
        this.$message.success('试卷上传成功')
      })
    })
  }
  // 客制化上传服务
  public async customRequest(action) {
    const file = action.file
    console.log(file)
    try {
      this.uploadFile(file)
    } catch (e) {
      console.log(e)
    }
  }
  // 上传前钩子
  public beforeUpload(file) {
    return false
  }
  // 上传文件控制
  public handleChange(info) {}
  // 查看题型说明
  public checkQtypeIntro() {
    window.open('http://help.17zuoye.com/?p=1572')
  }
  // 点击去发布
  public onPublish() {
    const source =
      this.fileList && this.fileList.length > 0 && this.fileList[0] && this.fileList[0].url
    const fileName =
      this.fileList && this.fileList.length > 0 && this.fileList[0] && this.fileList[0].name
    this.$router.push({
      path: '/assessment/publish',
      query: {
        subject: this.subject.nick,
        subject_id: this.subject.value,
        a: encodeURIComponent(source),
        fn: encodeURIComponent(fileName),
        s: 'QUESTION_BANK',
        f: encodeURIComponent(proSource)
      }
    })
  }
  // 点击删除文件
  public onDelete() {
    this.fileList = []
  }
}
